import AOS from 'aos';

if (typeof AOS == 'object') {
  AOS.init({
    once: true,
  });
}

function staggerAOS() {
  var staggerAOS = document.querySelectorAll(".stagger-aos");
  staggerAOS.forEach(function(item){
    var animateElements = item.querySelectorAll('[data-aos]');
    var counter = 1;

    animateElements.forEach(function(el){
      if (!el.hasAttribute("data-aos-delay")) {
        el.setAttribute('data-aos-delay', counter*150);
      }
      counter++;
    });
  });
}

try {
  document.addEventListener('DOMContentLoaded', staggerAOS);
} catch(err) {}